import React from 'react';
import {
  Button,
  Card,
  CardActions,
  Container
} from '@material-ui/core';
import Header from './Header';

function Welcome({ nextPage }) {
  return (
    <React.Fragment>
      <Header title="LET US HELP YOU CHOOSE THE PROGRAM THAT'S RIGHT FOR YOU" onClick={nextPage} />
      <Container maxWidth="md" style={{ height: '500px', padding: '1rem' }}>
        <Card
          raised
          style={{
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <div
            style={{
              width: '100%',
              overflow: 'hidden',
              paddingBottom: '56.25%',
              position: 'relative'
            }}
          >
            <iframe
              title="promo-video"
              src="https://player.vimeo.com/video/462839058?title=0&byline=0&portrait=0"
              style={{
                position: 'absolute',
                top: '0',
                left: '0',
                bottom: '0',
                right: '0',
                width: '100%',
                height: '100%',
                padding: '1rem'
              }}
              frameBorder="0"
              allow="autoplay; fullscreen"
              allowFullScreen
            >
            </iframe>
          </div>
          <CardActions>
            <Button
              color="primary"
              fullWidth
              onClick={nextPage}
              size="large"
              style={{ marginBottom: '1rem' }}
              variant="contained"
            >
              Find Your Program
            </Button>
          </CardActions>
        </Card>
      </Container>
    </React.Fragment>
  );
}

export default Welcome;